import React from "react";
import { Grid } from "@material-ui/core";
import { format } from "date-fns";
import { BasketItem } from "../../models/BasketItem";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { TicketAccess } from "../../models/TicketAccess";

interface IProps {
  itemBasket: BasketItem;
}

const BasketItemDetails: React.FC<IProps> = ({ itemBasket }: IProps) => {
  const isDesktop = useDesktopSize();
  const isListPrice = (item: BasketItem) => item.listPrice !== item.price;
  return (
    <React.Fragment>
      {isDesktop ? (
        <>
          <Grid item xs={5} className={"basket-item-wide"}>
            <div>
              <p>Typ: </p>
              <p>{itemBasket.assortName}</p>
            </div>

            {itemBasket.ticketAccess.length > 0 &&
              itemBasket.ticketAccess.map((item: TicketAccess) => (
                <div key={item.exerciseIds}>
                  <p>Dzień: </p>
                  <p key={item.exerciseIds}>{format(new Date(item.startDate), "dd.MM.yyyy")}</p>
                </div>
              ))}
          </Grid>
          <Grid item xs={5} className={"basket-item-wide"}>
            {itemBasket.ticketAccess.length > 0 && (
              <div>
                <p>Przedział: </p>
                <p>{itemBasket.ticketAccess[0].exerciseName} </p>
              </div>
            )}
            {itemBasket.showPrice && (
              <div>
                <p>Cena: </p>
                <p>
                  {isListPrice(itemBasket) && (
                    <span className={"list-price"}>{itemBasket.listPrice.toFixed(2)} zł</span>
                  )}{" "}
                  <span className={`${isListPrice(itemBasket) ? "red-class" : ""}`}>
                    {itemBasket.price.toFixed(2)}zł
                  </span>
                </p>
              </div>
            )}
            <div>
              <p>Ilość: </p>
              <p>{itemBasket.qnt}</p>
            </div>
            {Boolean(itemBasket.passCode) && (
              <div>
                <p>Numer: </p>
                <p>{itemBasket.passCode}</p>
              </div>
            )}
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={8} md={9} className={"basket-item-wide"}>
            <div>
              <p>Typ: </p>
              <p>{itemBasket.assortName}</p>
            </div>
            {itemBasket.ticketAccess.length > 0 &&
              itemBasket.ticketAccess.map((item: TicketAccess) => (
                <div key={item.exerciseIds}>
                  <p>Dzień: </p>
                  <p key={item.exerciseIds}>{format(new Date(item.startDate), "dd.MM.yyyy")}</p>
                </div>
              ))}
            {itemBasket.ticketAccess.length > 0 && (
              <div>
                <p>Przedział: </p>
                <p>{itemBasket.ticketAccess[0].exerciseName} </p>
              </div>
            )}
            <div>
              <p>Cena: </p>
              <p>
                {isListPrice(itemBasket) && <span className={"list-price"}>{itemBasket.listPrice.toFixed(2)} zł</span>}{" "}
                <span className={`${isListPrice(itemBasket) ? "red-class" : ""}`}>{itemBasket.price.toFixed(2)}zł</span>
              </p>
            </div>
            <div>
              <p>Ilość: </p>
              <p>{itemBasket.qnt}</p>
            </div>
            {Boolean(itemBasket.passCode) && (
              <div>
                <p>Numer: </p>
                <p>{itemBasket.passCode}</p>
              </div>
            )}
          </Grid>
        </>
      )}
    </React.Fragment>
  );
};

export default BasketItemDetails;
